import React from 'react';
import './Footer.css';
import {
  Linkedin,
  Twitter,
  Facebook,
  Instagram
} from 'lucide-react';
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <div className="footer-container">
      {/* Newsletter */}
      

      {/* Footer Section */}
      <div className="footer-content">
        {/* Logo + About */}
        <div className="footer-section about" style={{textAlign:"left"}}>
            <div className="navbar-logo">
              <div className="logo-circle"style={{color:"white",fontSize:"20px"}}>PKRVEDA</div>
              <span className="logo-text">Global</span>
            </div>
          <p>
          Your trusted partner for domestic and international trading of metal scraps, agricultural products, and medical equipment.          </p>
          <div className="social-icons">
            <Linkedin className="icon" color='white'/>
            <Twitter className="icon" color='white'/>
            <Facebook className="icon" color='white' />
            <Instagram className="icon" color='white' />
        </div>
        </div>

        {/* Pages */}
        <div className="footer-section" style={{textAlign:"left"}}>
          <h4>Page</h4>
          <ul>
            <li><Link to="/" style={{color:"white"}}>Home</Link></li>
            <li><Link to="/about" style={{color:"white"}}>About Us</Link></li>
            <li><Link to="/products/categories" style={{color:"white"}}>Product</Link></li>
            <li><Link to="/domestic-trading" style={{color:"white"}}>Domestic Trading</Link></li>
            <li><Link to="/international-trading" style={{color:"white"}}>International Trading</Link></li>
            <li><Link to="/contact" style={{color:"white"}}>Contact</Link></li>
          </ul>
        </div>
        <div className="footer-section" style={{textAlign:"left"}}>
        <h4><Link to="/products" style={{color:"white"}}>Product</Link></h4>
        <ul>
          <li><Link to="/products/alloy-metal-scrap" style={{color:"white"}}>Alloy Metal Scrap</Link></li>
                      <li><Link to="/products/non-alloy-metal-scrap" style={{color:"white"}}>Non-Alloy Metal Scrap</Link></li>
                      <li><Link to="/products/ferrous-metal" style={{color:"white"}}>Ferrous Metal</Link></li>
                      <li><Link to="/products/non-ferrous-metal" style={{color:"white"}}>Non-Ferrous Metal</Link></li>
                      <li><Link to="/products/specialty-mixed-scrap" style={{color:"white"}}>Specialty & Mixed Scrap</Link></li>
                      <li><Link to="/products/agro-products-export" style={{color:"white"}}>Agro Products Export</Link></li>
                      <li><Link to="/products/agriculture-commodities" style={{color:"white"}}>Agriculture Commodities</Link></li>
                      <li><Link to="/products/medical-equipment" style={{color:"white"}}>Medical Equipment</Link></li>
        </ul>
      </div>

        {/* Contact */}
        <div className="footer-section" style={{textAlign:"left"}}>
          <h4>Contact</h4>
          <p>Flat No.: 304, Block No.: 22,
Raintree Park Malayasian Township,
5th Phase KPHB,
VTC: Kukatpally, PO: Kukatpally
District: Medchal-Malkajgiri,
Telangana - 500072</p>
          <p>+91 9959941212</p>
          <p>psindhurareddy@pkrvedaglobal.com</p>
        </div>

        {/* Services */}
        
      </div>
            <hr style={{margin :"0 15px"}}/>
      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p className='footer-bottom-copy-right-text'>©2025 <a href="https://acetians.com" target='_blank' style={{textDecoration:'none',color:'inherit'}}>Acetians Technologies Pvt Ltd</a> </p>
        <div className="bottom-links">
          
          
          
        </div>
      </div>
    </div>
  );
};

export default Footer;
